import React from 'react';
import { Icon } from '@iconify/react';

export default function PhotoUploadSection({
  isGuest,
  user,
  userName,
  onOpenMyPage,
  onGoogleLogin,
  onKakaoLogin,
  imagePreview,
  onRemoveImage,
  onPickFile,
  fileInputRef,
  onImageUpload,
}) {
  return (
    <div className="photo-section-card">
      <div className="photo-section-header">
        <h3 className="photo-section-title">짤깍 Zzal-Kkak</h3>
        <div className="photo-section-header-right">
          {isGuest && !user && (
            <div className="photo-guest-login-actions">
              <span className="photo-guest-login-label">로그인</span>
              <button className="photo-profile-btn photo-guest-login-btn photo-guest-google-btn" onClick={onGoogleLogin}>
                <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9232 12.0477 13.5614V15.8195H14.9564C16.6582 14.2527 17.64 11.9454 17.64 9.20454Z" fill="#4285F4"/>
                  <path d="M9 18C11.43 18 13.467 17.1941 14.9564 15.8195L12.0477 13.5614C11.2418 14.1014 10.2109 14.4204 9 14.4204C6.65454 14.4204 4.67182 12.8373 3.96409 10.71H0.957275V13.0418C2.43818 15.9832 5.48182 18 9 18Z" fill="#34A853"/>
                  <path d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957273C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957273 13.0418L3.96409 10.71Z" fill="#FBBC05"/>
                  <path d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65454 3.57955 9 3.57955Z" fill="#EA4335"/>
                </svg>
                <span>구글</span>
              </button>
              <button className="photo-profile-btn photo-guest-login-btn photo-guest-kakao-btn" onClick={onKakaoLogin}>
                <span>카카오</span>
              </button>
            </div>
          )}

          {user && userName && (
            <button className="photo-profile-btn" onClick={onOpenMyPage}>
              <div className="photo-profile-avatar">{userName.charAt(0).toUpperCase()}</div>
              <span className="photo-profile-name">{userName}</span>
            </button>
          )}

          <div className="photo-section-icon">
            <Icon icon="solar:gallery-bold" width={20} height={20} />
          </div>
        </div>
      </div>

      {imagePreview ? (
        <div className="photo-preview-container">
          <img src={imagePreview} alt="업로드된 이미지" className="photo-preview" />
          <button className="photo-remove-btn" onClick={onRemoveImage}>
            ✕
          </button>
        </div>
      ) : (
        <div className="photo-upload-area" onClick={onPickFile}>
          <div className="photo-upload-plus">+</div>
          <p className="upload-text">사진을 선택해주세요</p>
          <p className="upload-hint">탭하여 업로드</p>
        </div>
      )}

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={onImageUpload}
        className="photo-file-input"
      />
    </div>
  );
}


